import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { cognito } from './config';

const getUserPool = () => new CognitoUserPool(cognito);

export { getUserPool };
